module.exports = __webpack_public_path__ + "assets/img/37_1477.ba8e3609.jpg";